import { Account, AccountCreditEntry, Auditable, InvoiceLine, Lockable, Procedure, SortParams, Surgery } from "..";

export interface Invoice extends Auditable, Lockable {
    name: string;
    accountId: number;
    totalAmount: number;
    balance: number;
    qboInvoiceId?: string;
    qboTermId?: string;
    procedureId?: number;
    procedure2Id?: number;
    surgeryId?: number;
    poNumber?: string;
    memo?: string;
    internalNotes?: string;
    dateSent?: string;
    dateDue?: string;
    isFlagged: boolean;
    flagNote?: string;
    isPaid: boolean; // auto-calculated from balance

    lines?: InvoiceLine[];
    account?: Account;
    procedure?: Procedure;
    procedure2?: Procedure;
    surgery?: Surgery;
    accountCreditEntry?: AccountCreditEntry;
}

export enum InvoiceStatus {
    Created = "Created",
    ExportedToQBO = "Exported to QBO",
    SentButUnpaid = "Sent to Client, Unpaid",
    Paid = "Paid",
}

export interface InvoiceWithStatus extends Invoice {
    status: InvoiceStatus;
}

export const DefaultInvoiceQueryParams = {
    accountId: "",
};

export const DefaultInvoiceSortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};
